import React from 'react';
import { Heart } from 'lucide-react';
import { imageData, getAltText } from '../../data/images';

const ExperiencesSection = ({ language, currentContent, scrollToSection }) => {
  const { experienceImages } = imageData;

  return (
    <section className="py-20 bg-gradient-to-br from-tilcara-orange/10 to-red-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-dancing">
            {currentContent.experiences.title}
          </h2>
          <p className="text-xl text-tilcara-orange font-medium mb-4">
            {currentContent.experiences.subtitle}
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {currentContent.experiences.humanSubtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {/* Outdoor Living */}
          <div className="space-y-6">
            <div className="relative overflow-hidden rounded-2xl shadow-lg group">
              <img
                src={experienceImages.sharedSpaces[0].src}
                alt={getAltText(experienceImages.sharedSpaces[0], language)}
                className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <h3 className="text-xl font-semibold mb-1">
                  {currentContent.experiences.sharedSpaces.title}
                </h3>
                <p className="text-sm opacity-90">
                  {currentContent.experiences.sharedSpaces.description}
                </p>
              </div>
            </div>
            <img
              src={experienceImages.sharedSpaces[1].src}
              alt={getAltText(experienceImages.sharedSpaces[1], language)}
              className="w-full h-48 object-cover rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            />
          </div>

          {/* Views & Nature */}
          <div className="space-y-6">
            <img
              src={experienceImages.views[0].src}
              alt={getAltText(experienceImages.views[0], language)}
              className="w-full h-48 object-cover rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            />
            <div className="relative overflow-hidden rounded-2xl shadow-lg group">
              <img
                src={experienceImages.views[1].src}
                alt={getAltText(experienceImages.views[1], language)}
                className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <h3 className="text-xl font-semibold mb-1">
                  {currentContent.experiences.uniqueViews.title}
                </h3>
                <p className="text-sm opacity-90">
                  {currentContent.experiences.uniqueViews.description}
                </p>
              </div>
            </div>
          </div>

          {/* Night Life & Community */}
          <div className="space-y-6">
            <div className="relative overflow-hidden rounded-2xl shadow-lg group">
              <img
                src={experienceImages.nights[0].src}
                alt={getAltText(experienceImages.nights[0], language)}
                className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <h3 className="text-xl font-semibold mb-1">
                  {currentContent.experiences.magicalNights.title}
                </h3>
                <p className="text-sm opacity-90">
                  {currentContent.experiences.magicalNights.description}
                </p>
              </div>
            </div>
            <img
              src={experienceImages.nights[1].src}
              alt={getAltText(experienceImages.nights[1], language)}
              className="w-full h-48 object-cover rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            />
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <div className="bg-white/80 backdrop-blur-md rounded-2xl p-8 shadow-lg max-w-2xl mx-auto">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              {currentContent.experiences.callToAction.title}
            </h3>
            <p className="text-gray-600 mb-6">
              {currentContent.experiences.callToAction.description}
            </p>
            <button
              onClick={() => scrollToSection('booking')}
              className="btn-tilcara inline-flex items-center space-x-2"
            >
              <Heart className="h-5 w-5" />
              <span>{currentContent.experiences.callToAction.button}</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperiencesSection;
